export default "__VITE_ASSET__CtLG8RnG__"